import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Typography } from "@material-ui/core";
import { BoltOutlined } from "@mui/icons-material";

import MomentsUser from "../../components/MomentsUser";
import MainHeader from "../../components/MainHeader";
import ForbiddenPage from "../../components/ForbiddenPage";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";

const getIsDarkMode = (theme) =>
  theme.palette.type === "dark" || theme.palette.mode === "dark";

const useStyles = makeStyles((theme) => {
  const isDarkMode = getIsDarkMode(theme);

  return {
    page: {
      width: "100%",
      minHeight: "100%",
      padding: theme.spacing(1.5),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
      },
    },
    hero: {
      position: "relative",
      overflow: "hidden",
      borderRadius: 28,
      padding: theme.spacing(3, 3, 3.5),
      marginBottom: theme.spacing(2.5),
      border: `1px solid ${isDarkMode ? "rgba(148,163,184,0.16)" : "rgba(15,23,42,0.08)"}`,
      background: isDarkMode
        ? "linear-gradient(135deg, rgba(15,23,42,0.98) 0%, rgba(30,41,59,0.92) 55%, rgba(37,99,235,0.18) 100%)"
        : "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(241,245,249,0.96) 58%, rgba(99,102,241,0.12) 100%)",
      boxShadow: isDarkMode
        ? "0 30px 60px rgba(2, 6, 23, 0.34)"
        : "0 24px 48px rgba(15, 23, 42, 0.10)",
    },
    heroGlow: {
      position: "absolute",
      top: -50,
      right: -30,
      width: 220,
      height: 220,
      borderRadius: "50%",
      background: isDarkMode
        ? "radial-gradient(circle, rgba(59,130,246,0.32) 0%, rgba(59,130,246,0) 72%)"
        : "radial-gradient(circle, rgba(99,102,241,0.20) 0%, rgba(99,102,241,0) 72%)",
      pointerEvents: "none",
    },
    heroBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      borderRadius: 999,
      padding: "8px 14px",
      marginBottom: theme.spacing(1.75),
      fontWeight: 700,
      fontSize: 12,
      letterSpacing: 0.3,
      color: isDarkMode ? "#dbeafe" : theme.palette.primary.main,
      background: isDarkMode
        ? "rgba(59,130,246,0.16)"
        : "rgba(99,102,241,0.10)",
      border: `1px solid ${isDarkMode ? "rgba(96,165,250,0.18)" : "rgba(99,102,241,0.14)"}`,
      width: "fit-content",
      position: "relative",
      zIndex: 1,
    },
    title: {
      position: "relative",
      zIndex: 1,
      color: theme.palette.text.primary,
      fontWeight: 800,
      letterSpacing: -1,
      marginBottom: theme.spacing(1),
    },
    subtitle: {
      position: "relative",
      zIndex: 1,
      color: theme.palette.text.secondary,
      maxWidth: 760,
      lineHeight: 1.7,
      fontSize: 15,
    },
    boardShell: {
      borderRadius: 28,
      padding: theme.spacing(2.5),
      border: `1px solid ${isDarkMode ? "rgba(148,163,184,0.14)" : "rgba(15,23,42,0.06)"}`,
      background: isDarkMode
        ? "linear-gradient(180deg, rgba(15,23,42,0.80) 0%, rgba(15,23,42,0.68) 100%)"
        : "linear-gradient(180deg, rgba(255,255,255,0.75) 0%, rgba(248,250,252,0.90) 100%)",
      boxShadow: isDarkMode
        ? "0 24px 48px rgba(2, 6, 23, 0.24)"
        : "0 18px 36px rgba(15, 23, 42, 0.08)",
      backdropFilter: "blur(12px)",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1.5),
        borderRadius: 22,
      },
    },
  };
});

const ChatMoments = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);

  return user.profile === "user" && user.allowRealTime === "disabled" ? (
    <ForbiddenPage />
  ) : (
    <MainHeader>
      <div className={classes.page}>
        <Paper elevation={0} className={classes.hero}>
          <div className={classes.heroGlow} />

          <div className={classes.heroBadge}>
            <BoltOutlined style={{ fontSize: 16 }} />
            <span>Live Board</span>
          </div>

          <Typography variant="h3" className={classes.title}>
            {i18n.t("servicePanel.allowRealTime")}
          </Typography>

          <Typography className={classes.subtitle}>
            Painel acompanhamento de conversas, pendências
            e agentes em tempo real.
          </Typography>
        </Paper>

        <Paper elevation={0} className={classes.boardShell}>
          <MomentsUser />
        </Paper>
      </div>
    </MainHeader>
  );
};

export default ChatMoments;
